"use strict";

import Modal from 'bootstrap/js/dist/alert';

export function init() {
    let alertTriggerList = [].slice.call(document.querySelectorAll('.alert'))
    let alertList = alertTriggerList.map(function (alertTriggerEl) {
        return new Modal(alertTriggerEl);
    })
}